import { connect } from 'react-redux';
import VrboRefreshMessage from './VrboRefreshMessage';

const mapStateToProps = ({ system: { isTouchDevice }}) => ({ isTouchDevice });
export default connect(mapStateToProps)(VrboRefreshMessage);